/**
 * openLogActualsDialog · Feb 2027
 * ================================================================
 * Small window-event helper so any part of the app can request the
 * `LogThisMonthModal` (a.k.a. "Log Actuals dialog") to open without
 * needing a React ref or context chain to the OperatingModeShell.
 *
 * The shell listens for `tlb:open-log-actuals` and drives its
 * `openLog(tab)` callback. `tab` is one of:
 *   - "revenue"  · default; the classic Log Actuals surface
 *   - "snapshot" · Operating Health snapshot form
 *
 * Founders on a NON-operating (launching) business will have no
 * listener mounted, so callers should still ship a
 * meaningful fallback — typically a navigate() to the standalone
 * `/business/:id/log-actuals` page.
 */

export const LOG_ACTUALS_EVENT = "tlb:open-log-actuals";

/**
 * Dispatch a request to open the Log Actuals dialog.
 * Returns `true` if a listener was mounted (and the dialog will
 * open), `false` if nothing intercepted the event (caller should
 * take a fallback route).
 */
export function openLogActualsDialog(tab = "revenue") {
  if (typeof window === "undefined") return false;
  // `CustomEvent.defaultPrevented` doubles as the "handled" flag —
  // the shell's listener calls `evt.preventDefault()` once it has
  // driven the dialog open, so unhandled dispatches can fall
  // through to a navigate() call.
  const evt = new CustomEvent(LOG_ACTUALS_EVENT, {
    detail: { tab: tab === "snapshot" ? "snapshot" : "revenue" },
    cancelable: true,
  });
  window.dispatchEvent(evt);
  return evt.defaultPrevented;
}
